<template>
  <div class="top_nav">
    <div class="nav_menu">
      <nav class="flex top_nav--main">
        <div class="menu--icon">
          <a @click="toggleMenu">
            <span v-if="isMenuToggled">
              <i class="fa fa-bars"></i>
              <p class="menu--icon__text">Open Menu</p>
            </span>
            <span v-else>
              <i class="fa fa-angle-double-left"></i>
              <p class="menu--icon__text">Hide Menu</p>
            </span>
          </a>
        </div>
        <div v-if="getPageTitle">
          <h2 class="page--title">
            {{ getPageTitle }}
          </h2>
        </div>
        <el-dropdown
          class="user-profile-dropdown"
          trigger="click">
          <span class="el-dropdown-link">
            <img
              :src="getUserThumb"
              class="user-profile-dropdown--thumb"
              alt="Profile picture"> {{ getUser.firstName }} {{ getUser.lastName }}
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="logout">
              <a class="flex">
                <i class="fa fa-sign-out"></i> Log Out
              </a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </nav>
    </div>
  </div>

</template>
<script>
import Auth from '@/auth';
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isMenuToggled: false,
      user: {},
    };
  },
  computed: {
    menuToggled() {
      return this.isMenuToggled;
    },
    ...mapGetters({
      getUser: 'getUser',
    }),
    getUserThumb() {
      return this.getUser.thumb;
    },
    getPageTitle() {
      return this.$route.matched[0].meta.pageTitle;
    },
  },
  created() {
    this.user = this.$store.getters.getUser;
    this.$store.dispatch('setUserInfo');
  },
  methods: {
    logout() {
      Auth.logout();
    },
    toggleMenu() {
      this.isMenuToggled = !this.isMenuToggled;
      this.$store.commit(types.TOGGLE_MENU, this.isMenuToggled);
    },
  },
};
</script>
<style style="scss" scoped>
.main_container .top_nav.toggled {
  width: 100%;
  float: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TopbarMenu.vue